var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/twotone/like-tag"
  }, /*#__PURE__*/React.createElement("g", {
    id: "like-tag"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 158",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M48.252 69.4501L56.302 75.7001C57.352 76.7501 59.702 77.2498 61.252 77.2498H71.152C74.252 77.2498 77.652 74.8999 78.452 71.7999L84.702 52.8498C86.002 49.1998 83.652 46.0999 79.752 46.0999H69.352C67.802 46.0999 66.502 44.7999 66.752 42.9999L68.052 34.6997C68.552 32.3497 67.0019 29.7497 64.6519 28.9997C62.5519 28.1997 59.952 29.2496 58.952 30.7996L48.302 46.6498",
    stroke: "#A461D8",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M35 69.4473V43.9968C35 40.3468 36.55 39.0469 40.2 39.0469H42.8C46.45 39.0469 48 40.3468 48 43.9968V69.4473C48 73.0973 46.45 74.3972 42.8 74.3972H40.2C36.55 74.3972 35 73.0973 35 69.4473Z",
    stroke: "#A461D8",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M90 94.7518H86.2C82.2 94.7518 78.4 96.3018 75.6 99.1018L67.05 107.552C63.15 111.402 56.8 111.402 52.9 107.552L44.35 99.1018C41.55 96.3018 37.7 94.7518 33.75 94.7518H30C21.7 94.7518 15 88.102 15 79.902V25.3518C15 17.1518 21.7 10.502 30 10.502H90C98.3 10.502 105 17.1518 105 25.3518V79.902C105 88.052 98.3 94.7518 90 94.7518Z",
    stroke: "#A461D8",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeTag);
export default __webpack_public_path__ + "static/media/like-tag.652b53b92c5a7d75cab5d29e75e9c51c.svg";
export { ForwardRef as ReactComponent };